export function generateLinearPointSizes(range, writeTo, sizeOffset) {
    const increment = (range.getY() - range.getX()) / (writeTo.getLength() - 1);
    const xMin = range.getX();
    for (let i = writeTo.getStart(), iEnd = writeTo.getEnd(); i < iEnd; ++i) {
        const x = xMin + increment * i;
        writeTo.setValue(i, sizeOffset, x);
    }
}
//# sourceMappingURL=generate-linear-point-sizes.js.map